// Función para aplicar la máscara de CUIT
export const applyCuitMask = (value) => {
    if (!value) return '';

    // Elimina cualquier carácter que no sea un número
    const numbersOnly = value.replace(/\D/g, '').slice(0, 11); // Máximo 11 dígitos

    const part1 = numbersOnly.slice(0, 2);
    const part2 = numbersOnly.slice(2, 10); // 8 dígitos
    const part3 = numbersOnly.slice(10, 11); // 1 dígito

    if (numbersOnly.length <= 2) {
        return part1;
    }
    if (numbersOnly.length <= 10) {
        return `${part1}-${part2}`;
    }
    return `${part1}-${part2}-${part3}`;
};
